import api from './api';

export interface IComentario {
    id_comentario: number;
    id_proposta: number;
    id_comentario_pai?: number | null;
    id_responsavel: number;
    tipo_responsavel: 'Operador' | 'Solicitante' | 'Profissional';
    id_destinatario?: number | null;
    tipo_destinatario?: 'Operador' | 'Solicitante' | 'Profissional' | 'OperadoresInterno' | null;
    texto: string;
    criado: string;
    modificado?: string | null;
    autor_nome?: string;
    destinatario_nome?: string | null;
    correspondentDesvinculado?: boolean;
    respostas?: IComentario[];
}

export interface ICreateComentario {
    id_proposta: number;
    texto: string;
    id_destinatario?: number | null;
    tipo_destinatario?: 'Operador' | 'Solicitante' | 'Profissional' | 'OperadoresInterno' | null;
    id_comentario_pai?: number | null;
}

export interface ICreateResposta {
    id_proposta: number;
    id_comentario_pai: number;
    texto: string;
}

export const comentarioService = {
    async getComentarios(id_proposta: number): Promise<IComentario[]> {
        try {
            const response = await api.get(`/comentario/${id_proposta}`);
            
            if (response.data.status === 'success') {
                return response.data.result || [];
            }
            
            throw new Error(response.data.message || 'Erro ao buscar comentários');
        } catch (error: any) {
            console.error('Erro ao buscar comentários:', error);
            throw error;
        }
    },

    async createComentario(data: ICreateComentario): Promise<IComentario> {
        try {
            const response = await api.post('/comentario', data);
            
            if (response.data.status === 'success') {
                return response.data.result;
            }
            
            throw new Error(response.data.message || 'Erro ao criar comentário');
        } catch (error: any) {
            console.error('Erro ao criar comentário:', error);
            throw error;
        }
    },

    async getContador(id_proposta: number): Promise<number> {
        try {
            const response = await api.get(`/comentario-contador/${id_proposta}`);
            
            if (response.data.status === 'success') {
                return response.data.result || 0;
            }
            
            return 0;
        } catch (error: any) {
            console.error('Erro ao buscar contador de comentários:', error);
            return 0;
        }
    },

    async createResposta(data: ICreateResposta): Promise<IComentario> {
        try {
            const response = await api.post('/comentario', {
                id_proposta: data.id_proposta,
                id_comentario_pai: data.id_comentario_pai,
                texto: data.texto
            });
            
            if (response.data.status === 'success') {
                return response.data.result;
            }
            
            throw new Error(response.data.message || 'Erro ao criar resposta');
        } catch (error: any) {
            console.error('Erro ao criar resposta:', error);
            throw error;
        }
    },

    async updateComentario(id_comentario: number, texto: string): Promise<IComentario> {
        try {
            const response = await api.put(`/comentario/${id_comentario}`, {
                texto: texto.trim()
            });
            
            if (response.data.status === 'success') {
                return response.data.result;
            }
            
            throw new Error(response.data.message || 'Erro ao atualizar comentário');
        } catch (error: any) {
            console.error('Erro ao atualizar comentário:', error);
            throw error;
        }
    },

    async deleteComentario(id_comentario: number): Promise<{ quantidade_deletada: number }> {
        try {
            const response = await api.delete(`/comentario/${id_comentario}`);
            
            if (response.data.status === 'success') {
                return response.data.result;
            }
            
            throw new Error(response.data.message || 'Erro ao excluir comentário');
        } catch (error: any) {
            console.error('Erro ao excluir comentário:', error);
            throw error;
        }
    },

    async getDestinatarios(id_proposta: number): Promise<Array<{ id: number; nome: string; email: string; tipo: string; tipo_destinatario: string }>> {
        try {
            const response = await api.get(`/comentario-destinatarios/${id_proposta}`);
            
            if (response.data.status === 'success') {
                return response.data.result || [];
            }
            
            throw new Error(response.data.message || 'Erro ao buscar destinatários');
        } catch (error: any) {
            console.error('Erro ao buscar destinatários:', error);
            throw error;
        }
    }
};

export default comentarioService;

